export default (that) => [
  {
    field: 'seq',
    width: 100,
    align: 'center',
    fixed: 'left',
    type: 'seq',
    treeNode: true,
  },
  {
    field: 'defaultImageUrl',
    width: 70,
    title: that.$l('INDEX.table_label_image') || '图片',
    headerAlign: 'left',
    align: 'center',
    fixed: 'left',
    slots: { default: 'defaultImageUrl' },
  },
  {
    title: that.$l('INDEX.amz_sku_inv_goodsName') || '产品',
    field: 'goodsName',
    minWidth: 300,
    fixed: 'left',
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayName' },
  },
  {
    title: that.$l('INDEX.amz_sku_inv_avgPrice') || '平均单价',
    field: 'avgPrice',
    minWidth: 100,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.amz_sku_inv_skuInvQty') || '总库存数',
    field: 'skuInvQty',
    minWidth: 100,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.amz_sku_inv_skuInvAmount') || '总库存金额',
    field: 'skuInvAmount',
    minWidth: 140,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.amz_sku_inv_ftyInvQty') || '国内库存',
    field: 'ftyInvQty',
    minWidth: 100,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.amz_sku_inv_ftyInvAmount') || '国内库存金额',
    field: 'ftyInvAmount',
    minWidth: 140,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.amz_sku_inv_fbaTotalQty') || 'FBA总库存',
    field: 'fbaTotalQty',
    minWidth: 100,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.amz_sku_inv_fbaTotalAmount') || 'FBA总库存金额',
    field: 'fbaTotalAmount',
    minWidth: 140,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.amz_sku_inv_fbaAvailableQty') || 'FBA可售',
    field: 'fbaAvailableQty',
    minWidth: 100,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title:
      that.$l('INDEX.amz_sku_inv_fbaPendingRemoveQty') || 'FBA计划移除数量',
    field: 'fbaPendingRemoveQty',
    minWidth: 100,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.amz_sku_inv_fbaInboundQty') || 'FBA入库数量',
    field: 'fbaInboundQty',
    minWidth: 100,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.amz_sku_inv_fbaInboundWorkingQty') || 'FBA计划数量',
    field: 'fbaInboundWorkingQty',
    minWidth: 100,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.amz_sku_inv_fbaInboundRecvQty') || 'FBA入库收货数量',
    field: 'fbaInboundRecvQty',
    minWidth: 100,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.amz_sku_inv_fbaReservedQty') || 'FBA冻结数量',
    field: 'fbaReservedQty',
    minWidth: 100,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.amz_sku_inv_fbaUnfulfillableQty') || 'FBA不可售数量',
    field: 'fbaUnfulfillableQty',
    minWidth: 100,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.amz_sku_inv_ftyInvUpdateTime') || '国内库存更新时间',
    field: 'ftyInvUpdateTime',
    minWidth: 170,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.amz_sku_inv_fbaInvUpdateTime') || 'FBA库存更新时间',
    field: 'fbaInvUpdateTime',
    headerAlign: 'left',
    align: 'left',
    minWidth: 170,
    showHeaderOverflow: true,
  },
]
